
.root {
    /* full page printout */
    flex: 1;
    /* print margins */
    margin: 8mm;
    /* layout */
    display: grid;
    grid-template-columns: [main] auto;
    grid-template-rows: [header] 14mm [content] auto;
}

.name {
    grid-column: main;
    grid-row: header;
    /* text style */
    font-size: 9mm;
    font-weight: bold;
    text-align: center;
}

.map {
    grid-column: main;
    grid-row: content;
}
